export const column1 = {
  title: 'Explore Keen',
  links: [
    {
      name: 'About',
      link: '/help/aboutkeen'
    },
    {
      name: 'Articles',
      link: '/articles'
    },
    {
      name: 'Horoscopes',
      link: '/horoscope'
    },
    {
      name: 'Start for Free',
      link: '/deals-and-promotions'
    }
  ]
};

export const column2 = {
  title: 'Discover Advisors',
  links: [
    {
      name: 'Psychic Readings',
      link: '/psychic-readings/195'
    },
    {
      name: 'Love & Relationships',
      link: '/psychic-readings/love-relationships/635'
    },
    {
      name: 'Life Path & Advice',
      link: '/psychic-readings/life-path-advice/636'
    },
    {
      name: 'Tarot Card Readings',
      link: '/psychic-readings/tarot-card-readings/588'
    },
    {
      name: 'More Advisors',
      link: '/all-categories'
    }
  ]
};

export const column3 = {
  title: 'User Support',
  links: [
    {
      name: 'Help',
      link: `${process.env.NEXT_PUBLIC_KEEN_HELP}/hc/en-us`
    },
    {
      name: 'Customer Support',
      link: '/help/support'
    },
    {
      name: 'Affiliate Program',
      link: '/affiliate'
    },
    {
      name: 'Give Advice',
      link: '/give-advice'
    },
    {
      name: 'Sitemap',
      link: '/documents/help/sitemap.asp'
    }
  ]
};

export const column4 = {
  title: 'Community Insights',
  links: [
    {
      name: 'Our Guarantee',
      link: `${process.env.NEXT_PUBLIC_KEEN_HELP}/hc/en-us/articles/1500000300362-Keen-Satisfaction-Guarantee`
    },
    {
      name: 'User Agreement',
      link: `${process.env.NEXT_PUBLIC_KEEN_HELP}/hc/en-us/articles/360060613353-Keen-User-Agreement`
    },
    {
      name: 'Privacy',
      link: `${process.env.NEXT_PUBLIC_KEEN_HELP}/hc/en-us/articles/1500000300002-Ingenio-Privacy-Policy`
    },
    {
      name: 'Trademark',
      link: '/documents/corpinfo/trademark_notice.asp'
    },
    {
      name: 'Powered by Ingenio',
      link: '/documents/help/poweredby.asp'
    }
  ]
};
